module.exports = __webpack_public_path__ + "img/aParty_091123_H.45dcf38e.jpg";